/**
 * Client-side instrumentation.
 *
 * Sentry is DISABLED (2026-08-25, operator request). It was the single largest
 * dev-time client cost measured on this app: with the static
 * `import * as Sentry from "@sentry/nextjs"` that used to sit at the top of this
 * file, ~1.0 MB of unminified `@sentry/core` + `@sentry/conventions` chunks
 * loaded on every route in dev, and — because a DSN IS set in `.env.local` —
 * `Sentry.init` actually ran with `tracesSampleRate: 1.0`, wrapping every fetch
 * and navigation.
 *
 * The guard here was `if (dsn)`, which gated init but NOT the import, so the
 * bundle cost was paid unconditionally. Re-enabling means restoring the import
 * and the init block together, and re-arming `instrumentation.ts` (root) plus
 * the `withSentryConfig` wrapper in `next.config.ts`.
 *
 * Web Vitals reporting, performance marks, and long-task observers remain
 * stubbed (perf-monitoring re-enablement is tracked separately); these exports
 * are kept because Next.js and PerformanceMonitor import them.
 */
export function reportWebVitals(
 _metric: {
  id: string;
  name: "CLS" | "FCP" | "FID" | "INP" | "LCP" | "TTFB";
  value: number;
  rating: "good" | "needs-improvement" | "poor";
  delta: number;
  entries: PerformanceEntry[];
  navigationType: string;
 }
) {}

export function markPerformance(_name: string) {}

export function measurePerformance(_name: string, _startMark: string, _endMark?: string) {
    return undefined;
}

export function initPerformanceMonitoring() {}
